import { firestore } from '@/firebaseConfig'
import MapOpeningMessage from '@/model/MapOpeningMessage';
import UUIDUtils from '@/utils/UUIDUtils';

export default class MapOpeningMessageService {
    loadOpeningMessagesForMap(publisherId, mapId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("openingMessages").where("mapIds." + mapId, "==", true).get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new MapOpeningMessage(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    saveMapOpeningMessage(publisherId, mapOpeningMessage, saveAsLegacyOpeningMessage = false) {
        const promise = new Promise((resolve, reject) => {
            if (!mapOpeningMessage.id) {
                mapOpeningMessage.id = UUIDUtils.generateUUID();
            }

            if (!mapOpeningMessage.frequency) {
                mapOpeningMessage.frequency = "always";
            }

            firestore.collection("publishers").doc(publisherId).collection("openingMessages").doc(mapOpeningMessage.id).set(mapOpeningMessage.toJSON()).then(() => {
                if (saveAsLegacyOpeningMessage) {
                    const allPromises = [];

                    const legacyNotification = {
                        id: mapOpeningMessage.id,
                        frequency: mapOpeningMessage.frequency,
                        sequence: 0,
                        title: mapOpeningMessage.title,
                        message: mapOpeningMessage.message,
                        type: "popup",
                        when: "mapOpened"
                    }

                    for (const mapId in mapOpeningMessage.mapIds) {
                        if (mapOpeningMessage.mapIds[mapId]) {
                            if (mapOpeningMessage.active) {
                                allPromises.push(firestore.collection("publishers").doc(publisherId).collection("maps").doc(mapId).collection("notifications").doc(legacyNotification.id).set(legacyNotification));
                            } else {
                                allPromises.push(firestore.collection("publishers").doc(publisherId).collection("maps").doc(mapId).collection("notifications").doc(legacyNotification.id).delete());
                            }
                        }
                    }

                    Promise.all(allPromises).then(() => {
                        resolve();
                    }).catch((error) => {
                        reject(error);
                    });
                } else {
                    resolve();
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    deleteMapOpeningMessage(publisherId, mapId, mapOpeningMessageId) {
        return new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("openingMessages").doc(mapOpeningMessageId).delete().then(() => {
                firestore.collection("publishers").doc(publisherId).collection("maps").doc(mapId).collection("notifications").doc(mapOpeningMessageId).delete().then(() => {
                    resolve();
                }).catch((error) => {
                    reject(error);
                });
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
